import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../TestShow/TestShow.css";
import TeamSubcription from "../TeamSubcription/TeamSubcription";
import { END_URL } from "../../config";
import buttonloader from "../../images/buttonloader.gif";
import loadimg from "../../images/loader_wish.gif";
import Dashboard from "../Dashboard/Dashboard";

function PricePlan({onLoginChange,userdetail,token,globaltest}) {

    const subS = true;

    const [subscription, setSubscription] = useState(null);

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setLoading(true);

        const fetchSubscriptionDetail = async () => {
            try {
                
                const response = await axios.get(`${END_URL}/plan-price`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setSubscription(response.data);

                setLoading(false);

            } catch (error) {
                console.log('Error fetching subscription:', error);
            }
        };

        fetchSubscriptionDetail();
    }, []);

    return (
        <div className="test-show-main">

            <div className="container">

                <div className="row result-cont">

                    <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

                        <Dashboard globaltest={globaltest} />

                    </div>

                    <div className="col-12 col-sm-12 col-md-9 col-lg-9 newdash-col">
                    
                        {loading ? (

                                <div className="loader-container">

                                    <img src={loadimg} alt="Loading..." className="loader-gif" />

                                </div>

                            ) :  ( 

                                <TeamSubcription subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                            )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default PricePlan;
